import { Pencil, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

/** The review-and-edit screen. Every row jumps straight back to the question
 *  it came from, then returns here — nobody has to redo the whole flow. */
export const ReviewSummary = ({ groups, onEdit }) => (
  <div data-testid="review-summary" className="space-y-5">
    {groups.map((group) => (
      <section
        key={group.key}
        data-testid={`review-group-${group.key}`}
        className="overflow-hidden rounded-lg border border-border"
      >
        <header className="flex items-center justify-between gap-3 border-b border-border bg-[color:var(--tt-teal-mist)] px-4 py-2.5">
          <h3 className="text-sm font-bold text-[color:var(--tt-teal-deep)]">{group.title}</h3>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            data-testid={`review-edit-group-${group.key}`}
            onClick={() => onEdit(group.stepIndex)}
            className="h-7 shrink-0 px-2 text-xs font-semibold text-[color:var(--tt-teal-deep)] hover:bg-white"
          >
            <Pencil className="mr-1.5 h-3 w-3" aria-hidden="true" />
            Edit section
          </Button>
        </header>

        <dl className="divide-y divide-border">
          {group.items.map((item) => (
            <div
              key={item.path}
              data-testid={`review-row-${item.path}`}
              className="flex flex-col gap-1 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4"
            >
              <dt className="text-sm leading-snug text-foreground sm:max-w-[62%]">{item.label}</dt>
              <dd className="flex items-center justify-between gap-3 sm:justify-end">
                <span
                  data-testid={`review-value-${item.path}`}
                  className="font-amount text-sm font-bold text-foreground"
                >
                  {item.value}
                </span>
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  data-testid={`review-edit-${item.path}`}
                  onClick={() => onEdit(item.stepIndex, item.path)}
                  className="h-7 shrink-0 bg-white px-2.5 text-xs"
                  aria-label={`Edit: ${item.label}`}
                >
                  Edit
                </Button>
              </dd>
            </div>
          ))}
        </dl>
      </section>
    ))}

    <p className="flex items-start gap-2 rounded-lg border border-[color:var(--tt-teal-line)] bg-[color:var(--tt-teal-mist)] px-4 py-3 text-[13px] leading-relaxed text-[color:var(--tt-teal-deep)]">
      <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        Your price is built from exactly these figures. They haven't been independently verified,
        so please make sure they're right before you continue.
      </span>
    </p>
  </div>
);
